import { render, staticRenderFns } from "./Header-column.vue?vue&type=template&id=57a2e82e"
import script from "./Header-column.vue?vue&type=script&lang=js"
export * from "./Header-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports